import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import approvedImg from '@app/assets/images/approved.png';
import MunicipalityLogo from '@app/assets/images/Municipalitiesblack.png';
import moment from 'moment';
import { currencyFormat, numberFormat } from '.';
import { CountyInfoProps } from '@app/types';
let width: number = 0;
let height: number = 0;
let propertyCoordinate: number = 0;
let totalAmount: number = 0;
const labels: any = {
  legalDescription: 'Legal Description',
  verifyTaxCalculations: 'Verify Tax Calculations',
  waterReading: 'Water Reading',
  inspection: 'Inspection',
  additionalQuestions: 'Additional Questions',
  proofofTaxPayment: 'Proof Of Tax Payment',
};
const webUrl: string = process.env.REACT_APP_DOWNLOAD_URL || '';
export async function DownloadPDF({ transactionId, transactionData }: any) {
  const {
    municipalityData,
    creator,
    property,
    buyers,
    sellers,
    professionalUsers,
    assignmentChecklist,
    transactionPayments,
    transactionDocuments,
    titleCompany,
    mlsLink,
    countyInfo,
  } = transactionData;
  return new Promise(async (resolve, rejected) => {
    const PDF: jsPDF = new jsPDF('p', 'in', [8, 11.5]);
    width = PDF.internal.pageSize.getWidth();
    height = PDF.internal.pageSize.getHeight();
    await transactionInfo(PDF, municipalityData, creator, transactionId);
    await propertInfo(PDF, property, countyInfo, mlsLink);
    await documents(PDF, transactionDocuments);
    await addPage(PDF, propertyCoordinate);
    await whoisInvolved(PDF, buyers, sellers, professionalUsers, titleCompany);
    await addPage(PDF, propertyCoordinate);
    await checkList(PDF, assignmentChecklist);
    await addPage(PDF, propertyCoordinate);
    await paymentDue(PDF, transactionPayments);
    PDF.setTextColor('#00fff');
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      var blob: Blob = PDF.output('blob');
      window.open(URL.createObjectURL(blob));
    } else {
      PDF.save(
        `${
          municipalityData && municipalityData.transferDocumentTitle
            ? municipalityData.transferDocumentTitle
            : 'Generated'
        }_${moment().format('X')}`,
      );
    }
    resolve('success');
  });
}

/**
 *
 * @param PDF jspdf to export
 * @param yAxis y axis position
 */
async function addPage(PDF: jsPDF, yAxis: number) {
  if (yAxis > 9.5) {
    PDF.addPage([8, 11.5], 'p');
    propertyCoordinate = 0;
  }
}

async function checkBottomLength(PDF: jsPDF, y: number) {
  if (y > 9) {
    y += 1;
    await addPage(PDF, y);
  }
}
/**
 *
 * @param PDF jspdf to export transction details
 */

async function headingStyles(PDF: jsPDF) {
  PDF.setTextColor('#666');
  PDF.setFontSize(11);
  PDF.setLineHeightFactor(16);
}
/**
 *
 * @param PDF jspdf to export transction details
 */
async function valueStyles(PDF: jsPDF) {
  PDF.setTextColor('#110F1F');
  PDF.setFontSize(11);
  PDF.setLineHeightFactor(20);
}
/**
 *
 * @param PDF jspdf to export transction details
 */
async function HeaderStyles(PDF: jsPDF) {
  PDF.setFontSize(13);
  PDF.setLineHeightFactor(21);
  PDF.setTextColor('#110F1F');
}

/**
 *
 * @param PDF jsPdf
 * @param width width of pdf file
 * @param height height of pdf file
 * @param municipalityData municipality data of transaction
 * @param creator transaction creator
 */
async function transactionInfo(
  PDF: jsPDF,
  municipalityData: any,
  creator: any,
  transactionId: string,
) {
  const { user } = creator;
  const { logo, name } = municipalityData;
  const userName = user ? user.firstName + ' ' + user.lastName : '--';
  await headerImages(PDF, logo, transactionId);
  PDF.setFontSize(16);
  PDF.setTextColor('#080707');
  PDF.setLineHeightFactor(21);
  PDF.setFont('helvetica', 'bold');
  PDF.text(`${name}`, 1.4, 1.2);
  PDF.setFont('helvetica', 'normal');
  await headingStyles(PDF);
  PDF.text('Transaction Created by', 0.6, 1.9);
  await valueStyles(PDF);
  PDF.text(`${userName}`, 0.6, 2.1);
  PDF.text(
    `${moment(municipalityData.createdAt).format('MM/DD/YY')}`,
    0.6,
    2.3,
  );
  seperatorLine(PDF, 3, 3);
}

/**
 *
 * @param PDF jspdf to export
 * @param x2 x axis coordinate
 * @param y2 y axis coordinate
 */
function seperatorLine(PDF: jsPDF, x2: number, y2: number) {
  PDF.setLineWidth(0.01);
  PDF.setDrawColor('#ccc');
  PDF.line(width - 0.5, x2, 0.5, y2); // horizontal line
}

async function getMunicipalyLogoData(imgUrl: any) {
  return await fetch(`${webUrl}getFileDataFromBucket?src=${imgUrl}`)
    .then((response: any) => response.json())
    .then((data: any) => {
      if (data.success && data.bodyData && data.bodyData.data) {
        var binary = '';
        var bytes = new Uint8Array(data.bodyData.data);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return binary;
      }
    })
    .catch((error: any) => {
      return '';
    });
}
/**
 *
 * @param PDF jsPdf generator
 * @param logo logo of municipality
 */
async function headerImages(PDF: jsPDF, logo: string, transactionId: string) {
  let qrCodeImage: string = '';
  await QRCode.toDataURL(`${webUrl}transaction-details/${transactionId}`)
    .then(url => {
      qrCodeImage = url;
    })
    .catch(err => {
      console.error(err);
    });
  const approvedImgUrl: any = await getDataUrl(approvedImg);
  const mLogo: any = logo ? await getMunicipalyLogoData(logo) : '';
  const municipalityLogo: any = mLogo
    ? mLogo
    : await getDataUrl(MunicipalityLogo);
  PDF.addImage({
    imageData: qrCodeImage,
    x: width - 2,
    y: height - 11.2,
    width: 2,
    height: 2,
  });
  PDF.addImage({
    imageData: approvedImgUrl,
    x: width - 1.8,
    y: height - 9.3,
    width: 1.6,
    height: 0.5,
  });
  PDF.addImage({
    imageData: municipalityLogo,
    x: 0.5,
    y: 0.7,
    width: 0.8,
    height: 0.8,
  });
}

/**
 *
 * @param PDF jsPdf generator
 * @param property property information of transaction
 */
async function propertInfo(
  PDF: jsPDF,
  property: any,
  countyInfo: CountyInfoProps,
  mlsLink: string,
) {
  await headingStyles(PDF);
  propertyCoordinate = 0;
  PDF.text('Property Info', 0.5, propertyCoordinate + 3.5);
  propertyCoordinate += 3.5;
  PDF.text('Purchase Price', width - 4, propertyCoordinate);
  PDF.text('Closing Date', width - 1.5, propertyCoordinate);
  await valueStyles(PDF);
  PDF.setFont('helvetica', 'bold');
  PDF.text(`${property.type}`, 0.5, propertyCoordinate + 0.25);
  propertyCoordinate += 0.25;
  PDF.setFont('helvetica', 'normal');
  PDF.text(
    `${countyInfo && countyInfo.label ? countyInfo.label : '--'}`,
    0.5,
    propertyCoordinate + 0.25,
  );
  propertyCoordinate += 0.25;
  var propertyAddress = PDF.splitTextToSize(
    property.address || '--',
    width - 4.5,
  );
  PDF.text(`${propertyAddress}`, 0.5, propertyCoordinate + 0.2, {
    maxWidth: 3.5,
    lineHeightFactor: 1.2,
  });
  const addressDimensions: any = PDF.getTextDimensions('text');
  propertyCoordinate +=
    0.2 + propertyAddress.length
      ? addressDimensions.h * propertyAddress.length
      : 0;
  PDF.text(
    `${property.city || '--'},${property.state || '--'}`,
    0.5,
    propertyCoordinate + 0.2,
  );
  propertyCoordinate += 0.2;
  PDF.text(`${property.zipCode || '--'}`, 0.5, propertyCoordinate + 0.2);
  propertyCoordinate += 0.25;
  PDF.text(
    `${
      property.closingDate
        ? moment(property.closingDate).format('MM/DD/YY')
        : '--'
    }`,
    width - 1.5,
    3.75,
  );
  PDF.text(
    `${
      property.purchasePrice
        ? '$' + currencyFormat(property.purchasePrice)
        : '--'
    }`,
    width - 4,
    3.75,
  );
  await headingStyles(PDF);
  PDF.text('Notes', 0.5, propertyCoordinate + 0.4);
  propertyCoordinate += 0.4;
  PDF.setTextColor('#080707');
  PDF.setFont('helvetica', 'normal');
  var lines = PDF.splitTextToSize(property.notes || '--', width - 0.7);
  PDF.text(`${lines}`, 0.5, propertyCoordinate + 0.25, {
    maxWidth: 7.3,
    lineHeightFactor: 1.2,
  });
  const dimensions: any = PDF.getTextDimensions('text');
  await headingStyles(PDF);
  propertyCoordinate += 0.35 + dimensions.h * lines.length;
  PDF.text('MLS Link', 0.5, propertyCoordinate + 0.25);
  propertyCoordinate += 0.25;
  await valueStyles(PDF);
  PDF.text(`${mlsLink || '--'}`, 0.5, propertyCoordinate + 0.25);
  propertyCoordinate += 0.5;
  propertyCoordinate < 8.5 &&
    seperatorLine(PDF, propertyCoordinate, propertyCoordinate);
}

async function documents(PDF: jsPDF, documents: any) {
  await HeaderStyles(PDF);
  PDF.setFont('helvetica', 'bold');
  PDF.text('Documents', 0.5, propertyCoordinate + 0.4);
  propertyCoordinate += 0.4;
  if (documents && documents.length) {
    for (var i = 0; i <= documents.length; i++) {
      await addPage(PDF, propertyCoordinate);
      let document: any = documents[i];
      await documentSection(PDF, document, i);
    }
  } else {
    await valueStyles(PDF);
    PDF.text('No documents uploaded', 0.5, propertyCoordinate + 0.35);
    propertyCoordinate += 0.5;
  }
}

async function documentSection(PDF: jsPDF, document: any, i: number) {
  if (document) {
    PDF.setFont('helvetica', 'bold');
    await valueStyles(PDF);
    PDF.setDrawColor('#898989');
    PDF.text(
      `${document.title ? document.title : '--'}`,
      0.65,
      propertyCoordinate + 0.45,
    );
    propertyCoordinate += 0.45;
    PDF.setFont('helvetica', 'normal');
    PDF.text(
      `Uploaded on ${
        document.uploadedDate
          ? moment(document.uploadedDate).format('MM/DD/YY')
          : '--'
      }  by ${document.uploadedBy ? document.uploadedBy : '--'}`,
      0.65,
      propertyCoordinate + 0.25,
    );
    propertyCoordinate += 0.25;
    PDF.setTextColor('#666');
    var lines = PDF.splitTextToSize(document.notes || '', width - 0.7);
    PDF.text(`${lines}`, 0.65, propertyCoordinate + 0.25, {
      maxWidth: 6.5,
      lineHeightFactor: 1.2,
    });
    const dimensions: any = PDF.getTextDimensions('text');
    PDF.setLineWidth(0.01);
    PDF.roundedRect(
      0.5,
      propertyCoordinate - 0.5,
      width - 1,
      document.notes ? dimensions.h * lines.length + 0.8 : 0.7,
      0.1,
      0.1,
    );
    propertyCoordinate += document.notes
      ? dimensions.h * lines.length + 0.1
      : 0;
    propertyCoordinate += 0.15;
  }
}
/**
 *
 * @param n number to check even or odd
 * @returns boolean
 */
async function isEven(n: any) {
  return /^-?\d*[02468]$/.test(n);
}

/**
 *
 * @param PDF pdf generator
 * @param buyers buyer information of transaction
 * @param sellers seller information of transaction
 */
async function whoisInvolved(
  PDF: jsPDF,
  buyers: any,
  sellers: any,
  professionalUsers: any,
  titleCompany: string,
) {
  await addPage(PDF, propertyCoordinate);
  await HeaderStyles(PDF);
  PDF.setFont('helvetica', 'bold');
  await checkBottomLength(PDF, propertyCoordinate);
  PDF.text('Who is Involved?', 0.5, propertyCoordinate + 0.45);
  propertyCoordinate += 0.33;
  PDF.setFont('helvetica', 'normal');
  await headingStyles(PDF);
  PDF.text('Title Company', 0.5, propertyCoordinate + 0.4);
  propertyCoordinate += 0.4;
  await valueStyles(PDF);
  PDF.setFont('helvetica', 'bold');
  PDF.text(`${titleCompany}`, 0.5, propertyCoordinate + 0.25);
  propertyCoordinate += 0.3;
  await headingStyles(PDF);
  PDF.setFont('helvetica', 'normal');
  await checkBottomLength(PDF, propertyCoordinate);
  PDF.text('Buyer Details', 0.5, propertyCoordinate + 0.25);
  propertyCoordinate += 0.25;
  await usersInvolved(PDF, buyers);
  await headingStyles(PDF);
  await checkBottomLength(PDF, propertyCoordinate);
  PDF.text('Seller Details', 0.5, propertyCoordinate + 0.35);
  propertyCoordinate += 0.35;
  PDF.setFont('helvetica', 'normal');
  await usersInvolved(PDF, sellers);
  await addPage(PDF, propertyCoordinate);
  PDF.setTextColor('#666');
  await checkBottomLength(PDF, propertyCoordinate);
  PDF.text('Professional Users Details', 0.5, propertyCoordinate + 0.5);
  propertyCoordinate += 0.4;
  PDF.setFont('helvetica', 'normal');
  await professionalsInvolved(PDF, professionalUsers);
  seperatorLine(PDF, propertyCoordinate + 0.5, propertyCoordinate + 0.5);
  propertyCoordinate += 0.5;
}

/**
 *
 * @param PDF js pdf to export transaction details
 * @param assignments checklist assignments
 */
async function checkList(PDF: jsPDF, assignments: any) {
  await HeaderStyles(PDF);
  PDF.setFont('helvetica', 'bold');
  await checkBottomLength(PDF, propertyCoordinate);
  PDF.text('Task Checklist', 0.5, propertyCoordinate + 0.5);
  PDF.setFont('helvetica', 'normal');
  propertyCoordinate += 0.25;
  await assignmentChecklist(PDF, assignments);
}
/**
 *
 * @param PDF jspdf to export
 * @param payments payment details of transaction
 */
async function paymentDue(PDF: jsPDF, payments: any) {
  propertyCoordinate += 0.5;
  await HeaderStyles(PDF);
  await checkBottomLength(PDF, propertyCoordinate);
  PDF.setFont('helvetica', 'bold');
  PDF.text('Payment Due', 0.5, propertyCoordinate + 0.5);
  PDF.setFont('helvetica', 'normal');
  propertyCoordinate += 0.5;
  if (payments && payments.length) {
    totalAmount = payments
      .map((payment: any) => {
        if (payment) {
          payment.cost = payment.cost ? payment.cost.replace(/,/g, '') : 0;
        }
        return parseInt(payment.cost);
      })
      .reduce((prev: number, next: number) => prev + next);
  }
  for (var i = 0; i <= payments.length; i++) {
    let paymentDetails = payments[i];
    await addPage(PDF, propertyCoordinate);
    if (paymentDetails) {
      let { costItem, cost } = paymentDetails;
      PDF.setLineWidth(0.01);
      PDF.roundedRect(0.5, propertyCoordinate + 0.25, width - 1, 0.7, 0.1, 0.1);
      await headingStyles(PDF);
      PDF.text('Title', 0.65, propertyCoordinate + 0.5);
      PDF.text('Cost', width - 1.5, propertyCoordinate + 0.5);
      propertyCoordinate += 0.5;
      await valueStyles(PDF);
      PDF.text(`${costItem}`, 0.65, propertyCoordinate + 0.3);
      PDF.text(
        `$${currencyFormat(cost)}`,
        width - 1.5,
        propertyCoordinate + 0.3,
      );
      propertyCoordinate += 0.3;
    }
  }
  seperatorLine(PDF, propertyCoordinate + 0.5, propertyCoordinate + 0.5);
  await addPage(PDF, propertyCoordinate);
  propertyCoordinate += 0.5;
  await valueStyles(PDF);
  PDF.text('Total', width - 4.15, propertyCoordinate + 0.3);
  PDF.text(
    `$${currencyFormat(totalAmount)}`,
    width - 1.5,
    propertyCoordinate + 0.3,
  );
  propertyCoordinate += 0.25;
  const payeeData = payments && payments.length ? payments[0] : [];
  if (payeeData) {
    propertyCoordinate += 0.3;
    await addPage(PDF, propertyCoordinate);
    PDF.setLineWidth(0.01);
    PDF.roundedRect(0.5, propertyCoordinate, width - 4.75, 1.2, 0.1, 0.1);
    PDF.text(
      `Paid by ${payeeData.cardHolderName}`,
      0.65,
      propertyCoordinate + 0.3,
    );
    propertyCoordinate += 0.3;
    await headingStyles(PDF);
    PDF.text(
      `on ${
        payeeData.dateofPayment
          ? moment(payeeData.dateofPayment).format('Do MMMM YYYY')
          : '--'
      }`,
      0.65,
      propertyCoordinate + 0.25,
    );
    propertyCoordinate += 0.25;
    PDF.text(
      `**** **** **** ${payeeData.cardEnding || '--'}`,
      0.65,
      propertyCoordinate + 0.25,
    );
    propertyCoordinate += 0.25;
    PDF.text(
      `${payeeData.cardBrand ? payeeData.cardBrand.toUpperCase() : '--'}`,
      0.65,
      propertyCoordinate + 0.15,
    );
  }
}
/**
 *
 * @param PDF jspdf to export
 * @param assignments checklist assignment tasks
 */
async function assignmentChecklist(PDF: jsPDF, assignments: any) {
  for (const key of Object.keys(assignments)) {
    let assignment: any = assignments[key];
    if (assignment) {
      await addPage(PDF, propertyCoordinate);
      await valueStyles(PDF);
      PDF.setFont('helvetica', 'bold');
      PDF.text(`${labels[key]}`, 0.5, propertyCoordinate + 0.6);
      PDF.setFont('helvetica', 'normal');
      propertyCoordinate += 0.6;
      await headingStyles(PDF);
      PDF.text(
        `${(assignment.user
          ? assignment.user.firstName + ' ' + assignment.user.lastName
          : '--') +
          ' ' +
          (assignment.type ? assignment.type : '')} ${
          assignment.userType ? '- ' + assignment.userType : ''
        }`,
        0.5,
        propertyCoordinate + 0.3,
      );
      propertyCoordinate += 0.25;
      if (
        assignment.docSrc &&
        assignment.status &&
        assignment.status === 'COMPLETED'
      ) {
        const assignmentLogo: any = await getMunicipalyLogoData(
          assignment.docSrc,
        );
        if (assignmentLogo) {
          PDF.addImage({
            imageData: assignmentLogo,
            x: 0.5,
            y: propertyCoordinate + 0.2,
            width: 0.4,
            height: 0.4,
          });
          PDF.text(
            `${assignment.docName ? assignment.docName : ''}`,
            1.2,
            propertyCoordinate + 0.4,
          );
          propertyCoordinate += 0.3;
        }
      }
      PDF.setTextColor(
        `${assignment.status === 'PENDING' ? '#D63763' : '#188F71'}`,
      );
      PDF.text(
        `${
          assignment.status === 'PENDING'
            ? 'Pending'
            : assignment.status === 'COMPLETED'
            ? 'Completed'
            : ''
        }`,
        width - 1.25,
        propertyCoordinate - (assignment.status === 'COMPLETED' ? 0.3 : 0),
      );
      assignment.status &&
        assignment.status === 'COMPLETED' &&
        PDF.text(
          `On ${
            assignment.completedAt
              ? moment(assignment.completedAt).format('DD/MM/YYYY')
              : '--'
          }`,
          width - 1.5,
          propertyCoordinate,
        );
      propertyCoordinate += 0.25;
      await headingStyles(PDF);
      if (
        assignment.exemption &&
        assignment.exemption.reasons &&
        assignment.exemption.reasons.length
      ) {
        const exemptionDetail: string = await assignment.exemption.details;
        const reasons: any = await assignment.exemption.reasons;
        const exemption = reasons.filter((reason: any) => {
          return reason.checked;
        });
        if (exemption && exemption.length) {
          PDF.text(`Exemption Reasons`, 0.5, propertyCoordinate + 0.25);
          propertyCoordinate += 0.25;
          await valueStyles(PDF);
          for (var r = 0; r <= reasons.length; r++) {
            let reason = await reasons[r];
            if (reason && reason.checked) {
              PDF.text(
                `${r + 1}. ${reason.exemption}`,
                0.5,
                propertyCoordinate + 0.25,
              );
              propertyCoordinate += 0.25;
            }
          }
          await headingStyles(PDF);
          PDF.text(`Exemption Details`, 0.5, propertyCoordinate + 0.3);
          await valueStyles(PDF);
          propertyCoordinate += 0.25;
          PDF.text(
            `${exemptionDetail || '--'}`,
            0.5,
            propertyCoordinate + 0.25,
          );
          propertyCoordinate += 0.25;
        }
      }
      if (assignment.taxAmount) {
        PDF.text(
          `Verified Tax Amount - ${
            assignment.taxAmount ? '$' + assignment.taxAmount : '--'
          }`,
          0.5,
          propertyCoordinate + 0.15,
        );
        propertyCoordinate += 0.25;
      }
      if (assignment.taxPaymentReceiptNumber && assignment.dateofTaxPayment) {
        PDF.text(
          `Receipt Number - ${assignment.taxPaymentReceiptNumber}`,
          0.5,
          propertyCoordinate + 0.3,
        );
        propertyCoordinate += 0.25;
        PDF.text(
          `Date of Payment - ${
            assignment.dateofTaxPayment
              ? moment(assignment.dateofTaxPayment).format('MMM DD YYYY')
              : '--'
          }`,
          0.5,
          propertyCoordinate + 0.25,
        );
        propertyCoordinate += 0.25;
      }
      if (assignment.answers) {
        let { answers } = assignment;
        if (answers && answers.length) {
          for (var a = 0; a <= answers.length; a++) {
            let qstnAns = await answers[a];
            if (qstnAns && qstnAns.question) {
              await addPage(PDF, propertyCoordinate);
              await questionAnsForamtion(PDF, qstnAns);
            }
          }
        }
      }
      if (assignment.notes || assignment.inspectionNotes) {
        let notes = (await assignment.notes)
          ? assignment.notes
          : assignment.inspectionNotes
          ? assignment.inspectionNotes
          : '--';
        PDF.setFontSize(12);
        PDF.setLineHeightFactor(18);
        PDF.setTextColor('#666');
        PDF.setFont('helvetica', 'normal');
        var notesLines = PDF.splitTextToSize(notes || '--', width - 0.7);
        PDF.text(
          `${notesLines}`,
          0.5,
          propertyCoordinate + (assignment.docName ? 0.25 : 0.1),
          {
            maxWidth: 7.3,
            lineHeightFactor: 1.2,
          },
        );
        const notesDimenstions = PDF.getTextDimensions('text');
        propertyCoordinate += 0.15 + notesDimenstions.h * notesLines.length;
      }
      PDF.setLineDashPattern([0.1, 0.1, 0.1, 0.1], 60);
      seperatorLine(PDF, propertyCoordinate + 0.25, propertyCoordinate + 0.25);
    }
  }
  PDF.setLineDashPattern([], 0);
}

async function questionAnsForamtion(PDF: jsPDF, qstnAns: any) {
  await valueStyles(PDF);
  PDF.setFont('helvetica', 'bold');
  var questionLines = PDF.splitTextToSize(qstnAns.question, width - 0.7);
  PDF.text(`${questionLines}`, 0.5, propertyCoordinate + 0.25, {
    maxWidth: 7.3,
    lineHeightFactor: 1.2,
  });
  const questionDimensions: any = PDF.getTextDimensions('text');
  propertyCoordinate += 0.25 + questionDimensions.h * questionLines.length;
  await headingStyles(PDF);
  PDF.setFont('helvetica', 'normal');
  PDF.text(qstnAns.answer || '--', 0.5, propertyCoordinate + 0.25);
  propertyCoordinate += 0.4;
}
/**
 *
 * @param PDF js pdf to export
 * @param professional professional user details
 */
async function professionalsInvolved(PDF: jsPDF, professionalUsers: any) {
  if (professionalUsers && professionalUsers.length) {
    let users: any = await professionalUsers.map((user: any) => {
      let userInfo = user.user ? user.user : '';
      if (userInfo) {
        return {
          ...userInfo,
          name: userInfo.firstName + ' ' + userInfo.lastName,
          type: user.type || '',
        };
      } else {
        return [];
      }
    });
    var i,
      j,
      temporary,
      chunk = 2;
    for (i = 0, j = users.length; i < j; i += chunk) {
      temporary = users.slice(i, i + chunk);
      await addPage(PDF, propertyCoordinate);
      propertyCoordinate += 0.5;
      await checkBottomLength(PDF, propertyCoordinate);
      await buyersFormation(PDF, temporary, true);
    }
  }
}

/**
 *
 * @param PDF jspdf to export
 * @param buyers buyer information of transaction
 */
async function usersInvolved(PDF: jsPDF, buyers: any) {
  if (buyers && buyers.length) {
    var i,
      j,
      temporary,
      chunk = 2;
    for (i = 0, j = buyers.length; i < j; i += chunk) {
      temporary = buyers.slice(i, i + chunk);
      await addPage(PDF, propertyCoordinate);
      propertyCoordinate += 0.4;
      await buyersFormation(PDF, temporary);
    }
  }
}

async function buyersFormation(
  PDF: jsPDF,
  array: any,
  isProfessional?: boolean,
) {
  if (array && array.length) {
    for (var i = 0; i <= array.length; i++) {
      let information: any = await array[i];
      if (information) {
        let isEvenNumber: boolean = await isEven(i);
        await valueStyles(PDF);
        PDF.setFont('helvetica', 'bold');
        propertyCoordinate =
          propertyCoordinate === 0
            ? propertyCoordinate + 0.35
            : isEvenNumber
            ? propertyCoordinate
            : propertyCoordinate - (isProfessional ? 1.5 : 1.25);
        PDF.text(
          `${information.name || '--'}`,
          isEvenNumber ? 0.65 : width - 3.65,
          propertyCoordinate === 0
            ? propertyCoordinate + 0.5
            : propertyCoordinate,
        );
        if (isProfessional) {
          PDF.text(
            `${information.type +
              (information.company ? ',' + information.company : '') || '--'}`,
            isEvenNumber ? 0.65 : width - 3.65,
            propertyCoordinate + 0.25,
          );
          propertyCoordinate += 0.25;
        }

        PDF.text(
          `${
            information.subDetails &&
            information.subDetails.contactNameForBusiness
              ? information.subDetails.contactNameForBusiness
              : '--'
          }`,
          isEvenNumber ? 0.65 : width - 3.65,
          propertyCoordinate + 0.25,
        );
        propertyCoordinate += 0.25;
        PDF.setFont('helvetica', 'normal');
        PDF.setTextColor('#656A74');
        PDF.text(
          `${information.email || '--'}`,
          isEvenNumber ? 0.65 : width - 3.65,
          propertyCoordinate + 0.25,
        );
        propertyCoordinate += 0.25;
        PDF.setTextColor('#110F1F');
        PDF.text(
          `${numberFormat(information.phone) || '--'}`,
          isEvenNumber ? 0.65 : width - 3.65,
          propertyCoordinate + 0.25,
        );
        propertyCoordinate += 0.25;
        var addressLines = PDF.splitTextToSize(
          information.address || '--',
          width - 3.5,
        );
        PDF.text(
          `${addressLines}`,
          isEvenNumber ? 0.65 : width - 3.6,
          propertyCoordinate + 0.25,
          {
            maxWidth: 3.4,
            lineHeightFactor: 1.2,
          },
        );
        const dimensions: any = PDF.getTextDimensions('text');
        propertyCoordinate +=
          0.25 + (i > 0 ? dimensions.h * addressLines.length : 0);
        PDF.setLineWidth(0.01);
        PDF.roundedRect(
          isEvenNumber ? 0.5 : width - 3.75,
          propertyCoordinate -
            (isEvenNumber
              ? isProfessional
                ? 1.5
                : 1.25
              : (isProfessional ? 1.5 : 1.25) +
                dimensions.h * addressLines.length),
          isEvenNumber ? width - 4.4 : width - 4.5,
          information.address
            ? dimensions.h * addressLines.length + (isProfessional ? 1.6 : 1.35)
            : isProfessional
            ? 1.7
            : 1.45,
          0.1,
          0.1,
        );
        propertyCoordinate += 0.25;
      }
    }
  }
}

/**
 *
 * @param img image to convert into data uri
 * @returns
 */
async function getDataUrl(img: any) {
  let blob = await fetch(img).then(r => r.blob());
  let dataUrl = await new Promise(resolve => {
    let reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
  return dataUrl;
}
